/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Stat_CloudInputs */

const tr_landing_shortcuts_stat_cloud = /** @type {(inputs: Landing_Shortcuts_Stat_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esnek bulut alanı`)
};

const en_landing_shortcuts_stat_cloud = /** @type {(inputs: Landing_Shortcuts_Stat_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`flexible cloud storage`)
};

const de_landing_shortcuts_stat_cloud = /** @type {(inputs: Landing_Shortcuts_Stat_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flexibler Cloud-Speicher`)
};

const ru_landing_shortcuts_stat_cloud = /** @type {(inputs: Landing_Shortcuts_Stat_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`гибкое облачное хранилище`)
};

/**
* | output |
* | --- |
* | "flexible cloud storage" |
*
* @param {Landing_Shortcuts_Stat_CloudInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_stat_cloud = /** @type {((inputs?: Landing_Shortcuts_Stat_CloudInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Stat_CloudInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_stat_cloud(inputs)
	if (locale === "de") return de_landing_shortcuts_stat_cloud(inputs)
	if (locale === "ru") return ru_landing_shortcuts_stat_cloud(inputs)
	return tr_landing_shortcuts_stat_cloud(inputs)
});